<template>
  <div class="menubar-logo-container" :class="{'collapse':collapse}">
    <transition name="menubarLogoFade">
      <router-link v-if="collapse" key="collapse" class="menubar-logo-link" to="/">
        <img v-if="logo" :src="minilogo" class="menubar-logo">
        <h1 v-else class="menubar-title">{{ title }} </h1>
      </router-link>
      <router-link v-else key="expand" class="menubar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="menubar-logo">
        <h1 class="menubar-title">{{ title }} </h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
import settings from '@/settings'

export default {
  name: 'MenubarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      title: settings.title,
      logo: 'logoisag.png',
      minilogo: 'farolisag.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.menubarLogoFade-enter-active {
  transition: opacity 1.5s;
}
.menubarLogoFade-enter,
.menubarLogoFade-leave-to {
  opacity: 0;
}
.menubar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  // background: #2b2f3a;
  text-align: center;
  overflow: hidden;
  & .menubar-logo-link {
    height: 100%;
    width: 100%;
    & .menubar-logo {
      // width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }
    & .menubar-title {
      display: inline-block;
      margin: 0;
      color: #2b2f3a;
      // color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }
  &.collapse {
    .menubar-logo {
      margin-right: 0px;
    }
  }
}
</style>
